import { useState } from 'react';
import Card from 'components/card';
import { ReadPermissionGate } from 'components/PermissionGate';
import { PERMISSION_RESOURCES } from 'constants/permissions';
import { CountriesPanel } from './components/CountriesPanel';
import { FeeRulesPanel } from './components/FeeRulesPanel';
import { RouteRulesPanel } from './components/RouteRulesPanel';
import { SectorsPanel } from './components/SectorsPanel';
import { SendersPanel } from './components/SendersPanel';
import { SettingsPanel } from './components/SettingsPanel';

const TABS = [
  { key: 'senders', label: 'Senders' },
  { key: 'fee-rules', label: 'Fee Matrix' },
  { key: 'route-rules', label: 'Routing Matrix' },
  { key: 'countries', label: 'Countries' },
  { key: 'sectors', label: 'Sectors' },
  { key: 'settings', label: 'Settings' },
] as const;

type TTabKey = (typeof TABS)[number]['key'];

export const InvoicePaymentConfig = () => {
  const [tab, setTab] = useState<TTabKey>('senders');

  return (
    <ReadPermissionGate
      resource={PERMISSION_RESOURCES.INVOICE_CONFIG}
      fallback={
        <div className="mt-5 text-center text-gray-600 dark:text-white">
          You don't have access to the Invoice Payment configuration.
        </div>
      }
    >
      <div className="mt-3">
        <Card extra="p-4">
          <div className="mb-4 flex flex-wrap gap-2">
            {TABS.map(item => (
              <button
                key={item.key}
                onClick={() => setTab(item.key)}
                className={`rounded px-3 py-2 text-sm font-medium ${
                  tab === item.key
                    ? 'bg-brand-500 text-white'
                    : 'border border-gray-200 text-navy-700 dark:text-white'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
          {tab === 'senders' && <SendersPanel />}
          {tab === 'fee-rules' && <FeeRulesPanel />}
          {tab === 'route-rules' && <RouteRulesPanel />}
          {tab === 'countries' && <CountriesPanel />}
          {tab === 'sectors' && <SectorsPanel />}
          {tab === 'settings' && <SettingsPanel />}
        </Card>
      </div>
    </ReadPermissionGate>
  );
};

export default InvoicePaymentConfig;
